import React, { useState,useEffect} from 'react';
import { Paper,TableContainer,TableHead,TableRow,TableCell,TableBody,Table} from '@mui/material';
import Pagefoot from '../Pagefoot.jsx';
import Codes from '../Codes.jsx'
import UmbrellaRainAnimation from '../UmbrellaRainAnimation.jsx';
import LoadFailed from '../LoadFailed.jsx';

export const imageTitle = {
    fontSize:'smaller',
    color:'grey',
    fontStyle:'italic',
    fontFamily:'Times New Roman'
}

function ArticleContent({articleID}) {

    const [articleData, setArticleData] = useState(null)
    const [opacity, setOpacity] = useState(0);
    const [loading,setLoading] = useState(false)

    useEffect(() => {
        getArticleData()
    },[]);

    useEffect(() => {
        let timer;
        if (loading) {
            setOpacity(0); // 重置透明度为 0
            timer = setTimeout(() => {
                setOpacity(1); // 在 25 秒后设置透明度为 1
            }, 25000); // 25 秒
        }
        return () => clearTimeout(timer); // 清理计时器
    }, [loading]); // 监听 loading 状态
    
    const getArticleData = async () => {
        setLoading(true);
        try {
            const formData = new URLSearchParams();
            formData.append('id', articleID);
    
            const res = await fetch('https://api.sadatsunemyspace.uk/api/articlecontent', {
                method: 'POST',
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: formData.toString()
            });
            
            const jsonData = await res.json();

            if (jsonData && jsonData.data) {
                let parsedContent
                try {
                    parsedContent = JSON.parse(jsonData.data[0].content); // 解析 JSON
                } catch (error) {
                    console.error("JSON Parse Error:", error);
                    parsedContent = []; // 遇到错误设为空数组
                }
    
                setArticleData({
                    ...jsonData.data[0],
                    content: parsedContent
                });
                    
            } else {
                console.error("Invalid API response format:", jsonData);
                setArticleData(null);
            }
        } catch (error) {
            console.error("Error fetching article data:", error);
            setArticleData(null);
        } finally {
            setLoading(false);
        }
    };
    
    if (loading) return(
        <UmbrellaRainAnimation transparent={opacity}/>
    );
    if (!articleData || !articleData.content) return(
        <center>
            <p style={{fontFamily:'comicbold', fontSize:'x-large'}}>💾❌</p>
            <p style={{fontFamily:'comicbold', fontSize:'x-large'}}>No data available.</p>
        </center>
    ) ;

    return (
    <div>
        {articleData.content.length > 0 ? (
            
                    <div>
                        <p className='articletitle'>{articleData.title}</p>
                        <hr className='divideline' />
                        {articleData.content.map((item, index) => {

                            switch (item.type) {
                                case 'p':
                                    return <p className='nekopara' key={index}>{item.text}</p>;
                                case 'code':
                                    return <Codes key={index}>{item.value}</Codes>;
                                case 'table':
                                    {return(
                                    <TableContainer component={Paper}>
                                        <Table  size="small" aria-label="a dense table">
                                          <TableHead>
                                            <TableRow>
                                                {item.columns.map((column, index)=>{
                                                    return <TableCell key={index}>{column}</TableCell>
                                                })}
                                              
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {item.rows.map((row, rowIndex) => (
                                                <TableRow key={rowIndex} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    {row.map((cell, cellIndex) => (
                                                        <TableCell key={cellIndex} align="left">{cell}</TableCell>
                                                    ))}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        </Table>
                                      </TableContainer>
                                      )}
                                case 'image':
                                    if(item.link){
                                        return (
                                            <center key={index}>
                                                <a  href={item.link} >
                                                <img 
                                                    className="pic1" 
                                                    src={item.src} 
                                                    alt={item.alt} 
                                                    loading="lazy"
                                                    style={item.style} 
                                                />
                                                </a>
                                                <p  style={imageTitle}>{item.alt}</p>
                                            </center>
                                        );
                                    }else{
                                        return (
                                            <center key={index}>
                                                <img 
                                                    className="pic1" 
                                                    src={item.src} 
                                                    alt={item.alt} 
                                                    loading="lazy"
                                                    style={item.style} 
                                                />
                                                <p style={imageTitle}>{item.alt}</p>
                                            </center>
                                        );
                                    }
                                    
                                default:
                                    return null;
                            }
                            
                        })}
                        <Pagefoot towhere={
                            articleData.cate === 'rh' ? '/radiohobbyist' : 
                            articleData.cate === 'oth' ? '/others' : 
                            '/gis-tech-skills'
                        } date={articleData.date} />
                    </div>
                ) : (
                    <LoadFailed/>
                )}
    </div>
  );
}

export default ArticleContent;
